import { Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/CustomButton";
import TopBar from "../../../components/TopBar/TopBar";
import { getPendingStocksByClinic } from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import Location from "./Location";
import Service from "./Service";
import Stock from "./Stock";
import Supplier from "./Supplier";

const Inventory = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Service");
  const [penTblVsble, setPenTblVsble] = useState(false);
  const { pendingStocks } = useSelector((state) => state?.clinic);

  useEffect(() => {
    dispatch(getPendingStocksByClinic(`?type=pending&page=1&itemSize=0`));
  }, []);

  const handlePending = () => {
    setActiveTab("Stock");
    setPenTblVsble(true);
  };

  const handleChangeTab = (tab) => {
    setPenTblVsble(false);
    setActiveTab(tab);
  };

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <Grid container spacing={2}>
            {/* <Grid item xs={4} sm={4} md={2} lg={1.5} xl={1}>
              <Button
                text="Product"
                tabSelectdBtn={activeTab === "Product"}
                textBtn={activeTab !== "Product"}
                onClick={() => handleChangeTab("Product")}
                color={AppColors.grayBtn2}
              />
            </Grid> */}
            <Grid item xs={4} sm={4} md={2} lg={1.5} xl={1}>
              <Button
                text="Service"
                tabSelectdBtn={activeTab === "Service"}
                textBtn={activeTab !== "Service"}
                onClick={() => handleChangeTab("Service")}
                color={AppColors.grayBtn2}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={2} lg={1.5} xl={1}>
              <Button
                text="Stock"
                tabSelectdBtn={activeTab === "Stock"}
                textBtn={activeTab !== "Stock"}
                onClick={() => handleChangeTab("Stock")}
                color={AppColors.grayBtn2}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={2} lg={1.5} xl={1}>
              <Button
                text="Supplier"
                tabSelectdBtn={activeTab === "Supplier"}
                textBtn={activeTab !== "Supplier"}
                onClick={() => handleChangeTab("Supplier")}
                color={AppColors.grayBtn2}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={2} lg={1.5} xl={1}>
              <Button
                text="Location"
                tabSelectdBtn={activeTab === "Location"}
                textBtn={activeTab !== "Location"}
                onClick={() => handleChangeTab("Location")}
                color={AppColors.grayBtn2}
              />
            </Grid>
          </Grid>
        </Container>
        <div className="pos-absolute r80 top65">
          <Typography
            className="fs14 txt-semi-bold orange-color cursor"
            onClick={handlePending}
          >
            Pending {pendingStocks?.totalRecords}
          </Typography>
        </div>
      </TopBar>
      <div className="mt20">
        {/* {activeTab === "Product" && <ProductComponent />} */}
        {activeTab === "Service" && <Service />}
        {activeTab === "Stock" && (
          <Stock penTblVsble={penTblVsble} setPenTblVsble={setPenTblVsble} />
        )}
        {activeTab === "Supplier" && <Supplier />}
        {activeTab === "Location" && <Location />}
      </div>
    </>
  );
};

export default Inventory;
